import { useState } from 'react'
import { FiLock, FiX } from 'react-icons/fi'
import toast from 'react-hot-toast'
import { API_URL } from '../../config/api'
import { Btn } from '../../ui'

/*
 * ModalCambiarPasswordV2 — DS v2.
 * Usuario cambia su propia contraseña. Replica exactamente la lógica del
 * modal legacy en Fichaje.jsx (PUT /empleados/cambiar-password).
 */

const ModalCambiarPasswordV2 = ({ onClose, onSuccess }) => {
  const [form, setForm] = useState({ passwordActual: '', passwordNueva: '', passwordConfirmar: '' })
  const [guardando, setGuardando] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (form.passwordNueva !== form.passwordConfirmar) {
      toast.error('Las contraseñas no coinciden')
      return
    }
    if (form.passwordNueva.length < 6) {
      toast.error('La contraseña debe tener al menos 6 caracteres')
      return
    }

    setGuardando(true)
    try {
      const token = localStorage.getItem('token')
      const response = await fetch(`${API_URL}/empleados/cambiar-password`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({
          passwordActual: form.passwordActual,
          passwordNueva: form.passwordNueva
        })
      })

      if (response.ok) {
        toast.success('Contraseña cambiada correctamente')
        onSuccess?.()
        onClose()
      } else {
        const error = await response.json()
        toast.error(error.error || 'Error al cambiar contraseña')
      }
    } catch {
      toast.error('Error al cambiar contraseña')
    } finally {
      setGuardando(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="ui-card w-full max-w-md">
        {/* Header */}
        <div className="flex items-start justify-between p-5 border-b border-[var(--line)]">
          <div className="flex items-start gap-3">
            <div className="w-9 h-9 rounded-soft bg-[rgba(37,99,235,.10)] flex items-center justify-center">
              <FiLock size={15} className="text-[var(--brand-1)]" />
            </div>
            <div>
              <div className="eyebrow mb-1">Seguridad</div>
              <h3 className="font-display text-[20px] text-[var(--ink)] leading-tight">Cambiar contraseña.</h3>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 rounded-soft text-[var(--ink-3)] hover:text-[var(--ink)] hover:bg-[var(--bg-2)] transition-colors"
            aria-label="Cerrar"
            disabled={guardando}
          >
            <FiX size={16} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-5 space-y-4">
          <div>
            <label className="eyebrow block mb-1.5">Contraseña actual *</label>
            <input
              type="password"
              value={form.passwordActual}
              onChange={e => setForm({ ...form, passwordActual: e.target.value })}
              className="w-full px-3 py-2 bg-[var(--bg-2)] border border-[var(--line)] rounded-soft text-[14px] focus:outline-none focus:border-[var(--ink-3)]"
              required
              autoFocus
            />
          </div>

          <div>
            <label className="eyebrow block mb-1.5">Nueva contraseña *</label>
            <input
              type="password"
              value={form.passwordNueva}
              onChange={e => setForm({ ...form, passwordNueva: e.target.value })}
              className="w-full px-3 py-2 bg-[var(--bg-2)] border border-[var(--line)] rounded-soft text-[14px] focus:outline-none focus:border-[var(--ink-3)]"
              required
              minLength={6}
              placeholder="Mínimo 6 caracteres"
            />
          </div>

          <div>
            <label className="eyebrow block mb-1.5">Confirmar nueva contraseña *</label>
            <input
              type="password"
              value={form.passwordConfirmar}
              onChange={e => setForm({ ...form, passwordConfirmar: e.target.value })}
              className={`w-full px-3 py-2 bg-[var(--bg-2)] border rounded-soft text-[14px] focus:outline-none ${
                form.passwordConfirmar && form.passwordNueva !== form.passwordConfirmar
                  ? 'border-[#C13030] focus:border-[#C13030]'
                  : 'border-[var(--line)] focus:border-[var(--ink-3)]'
              }`}
              required
              minLength={6}
            />
            {form.passwordConfirmar && form.passwordNueva !== form.passwordConfirmar && (
              <p className="text-[11px] text-[#C13030] mt-1">Las contraseñas no coinciden</p>
            )}
          </div>

          <div className="flex gap-3 pt-1">
            <Btn type="button" variant="ghost" className="flex-1" onClick={onClose} disabled={guardando}>
              Cancelar
            </Btn>
            <Btn type="submit" variant="primary" className="flex-1" disabled={guardando}>
              {guardando ? 'Guardando…' : 'Cambiar contraseña'}
            </Btn>
          </div>
        </form>
      </div>
    </div>
  )
}

export default ModalCambiarPasswordV2
